import React from 'react';
import FormItemEditorControl from './FormItemEditorControl';
import FormItemTimeEditor from '../FormItemTimeEditor';
import FormItemTimeEditorForDataGrid from '../FormItemTimeEditorForDataGrid';
import FormItemTimeRender from '../renders/FormItemTimeRender';
import FormItemUtil from '../../utils/FormItemUtil';
import EditorFormType from '../../utils/EditorFormType';

export default class FormItemTimeEditorControl extends FormItemEditorControl
{
	constructor(menuItemId,formId,parent,xml,group,module,forLookup) {
		super(menuItemId,formId,parent,xml,group,module,forLookup);
		this.classAlias = "FormItemTimeEditorControl";
	}
	
	getDefaultDisplayLength()
	{
		return 12;
	}

	getProperty_ShowHour()
	{
		return true;
		return this.properties.ShowHour;
	}

	getProperty_ShowMinute()
	{
		return true;
		return this.properties.ShowMinute;
	}

	getProperty_ShowSecond()
	{
		return true;
		return this.properties.ShowSecond;
	}

	getDefaultValue()
	{
		var dvalue = super.getDefaultValue();
		if(dvalue == "")
		{
			dvalue = "00:00:00";
		}
		return dvalue;
	}

	getProperty_DisplayFormat()
	{
		let _displayStyle = this.getProperty_DisplayStyle();
		if(_displayStyle && _displayStyle.DisplayFormat)
		try
		{
			return _displayStyle.DisplayFormat.toUpperCase().replace(new RegExp("M","g"),"N");
		}
		catch(e)
		{

		}	
		return "";
	}

	getComponentInstance(parent,forLookup)
	{
		let layout = parent.Properties.Layout.Value;
		let displayLengthWidth = this.getDisplayLengthWidth();
		let label = this._cmdLabel?this._cmdLabel:this.getProperty_Label();
		let commonProps = this.getCommonProps();
		let displayLength=this.propertyDisplayLength?this.propertyDisplayLength:this.getProperty_DisplayLength();
		let displayHeight=this.getProperty_DisplayHeight();
		let notNull=this.propertyNotNull?this.propertyNotNull:this.getProperty_NotNull();
		let _initRecord = this.record;
		if(!_initRecord)
	    {
		  	if(!this.group)
		  	{
		  		let defaultValue = this.getDefaultValue();
		  		_initRecord = defaultValue;
		  	}
		}
		let displayStyle = this.getProperty_DisplayStyle();
		let displayFormat = this.getProperty_DisplayFormat();
		  this.component = <FormItemTimeEditor displayLengthWidth={displayLengthWidth} key={this.xml.id} 
		  			  displayLength={displayLength} displayHeight={displayHeight} notNull={notNull} moduleInstanceId={this.module.instanceUUId}
                      xml={this.xml} parentLayout={layout} forLookup={forLookup} groupAlias={this.groupAlias} formType={EditorFormType.FormModule}
                      dataField = {this.getDataField()} initRecord = {_initRecord} label={label} customStyle={this.getStyle()}
                      formId={this.formId} menuItemId={this.menuItemId} contextMenuData={this.contextMenuData}
                      showHour={this.getProperty_ShowHour()} showMinute={this.getProperty_ShowMinute()} showSecond={this.getProperty_ShowSecond()}
                      control={this} underQueryGroup={this.isUnderQueryGroup()} verticalAlign={this.getProperty_VAlignment()} 
					  cssStyle={this.getProperty_CSSStyle_Display()} displayStyle={displayStyle} displayFormat={displayFormat} {...commonProps}/>;
		return this.component;
	}

	getComponentInstanceForDataGrid(parent,forLookup)
	{
		return <FormItemTimeEditorForDataGrid key={this.xml.id} xml={this.xml} forLookup={forLookup} formType={EditorFormType.FormModule} control={this} groupAlias={this.groupAlias} moduleInstanceId={this.module.instanceUUId}
				verticalAlign={this.getProperty_VAlignment()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML} group={this.group}
				/>;
	}

	getRenderForDataGrid(forLookup)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		let displayFormat = this.getProperty_DisplayFormat();
		return <FormItemTimeRender contextMenuData={this.contextMenuData} group={this.group} forLookup={forLookup}
			dataField = {this.getDataField()} showHour={this.getProperty_ShowHour()} showMinute={this.getProperty_ShowMinute()} 
			showSecond={this.getProperty_ShowSecond()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML}
			textAlign={this.getProperty_Alignment()} moduleInstanceId={this.module.instanceUUId}
			verticalAlign={this.getProperty_VAlignment()} cssStyle={this.getProperty_CSSStyle_Display()}
			displayStyle={displayStyle} displayFormat={displayFormat}/>;
	}

	getRenderForDynamicColumn(dataField)
	{
		let displayStyle = this.getProperty_DisplayStyle();
		let displayFormat = this.getProperty_DisplayFormat();
		return <FormItemTimeRender contextMenuData={this.contextMenuData} group={this.group} forLookup={false}
			dataField = {dataField} showHour={this.getProperty_ShowHour()} showMinute={this.getProperty_ShowMinute()} 
			showSecond={this.getProperty_ShowSecond()} formId={this.formId} menuItemId={this.menuItemId} colXml={this.xml} gridXml={this.parentXML}
			textAlign={this.getProperty_Alignment()} moduleInstanceId={this.module.instanceUUId}
			verticalAlign={this.getProperty_VAlignment()} cssStyle={this.getProperty_CSSStyle_Display()}
			displayStyle={displayStyle} displayFormat={displayFormat}/>;
	}
}



// WEBPACK FOOTER //
// ./src/formItem/controls/FormItemTimeEditorControl.js